var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBill = function SvgBill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 0H6v8h14V0zm-7 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5c0 .8-.7 1.5-1.5 1.5H1v-7.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v2.4l4.4-4.4c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1L6.1 16h2.4c.8 0 1.5.7 1.5 1.5z"
  })));
};
export default SvgBill;